"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AirDropVerifierFactory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        constant: true,
        inputs: [
            {
                internalType: "bytes32",
                name: "messageHash",
                type: "bytes32",
            },
        ],
        name: "getEthSpecificMessageHash",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        payable: false,
        stateMutability: "pure",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "claimant",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "chainId",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "verifierAddress",
                type: "address",
            },
        ],
        name: "getMessageHash",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        payable: false,
        stateMutability: "pure",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "signer",
                type: "address",
            },
            {
                internalType: "address",
                name: "claimant",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "chainId",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "verifierAddress",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "signature",
                type: "bytes",
            },
        ],
        name: "isSignatureValid",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "pure",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "bytes32",
                name: "ethSpecificMessageHash",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "signature",
                type: "bytes",
            },
        ],
        name: "recoverSigner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "pure",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "bytes",
                name: "signature",
                type: "bytes",
            },
        ],
        name: "splitSignature",
        outputs: [
            {
                internalType: "bytes32",
                name: "r",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "s",
                type: "bytes32",
            },
            {
                internalType: "uint8",
                name: "v",
                type: "uint8",
            },
        ],
        payable: false,
        stateMutability: "pure",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "signer",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "messageHash",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "signature",
                type: "bytes",
            },
        ],
        name: "verify",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "pure",
        type: "function",
    },
];
const _bytecode = "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";
class AirDropVerifierFactory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (args.length === 1) {
            super(_abi, _bytecode, args[0]);
        }
        else {
            super(...args);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.AirDropVerifierFactory = AirDropVerifierFactory;
AirDropVerifierFactory.bytecode = _bytecode;
AirDropVerifierFactory.abi = _abi;
//# sourceMappingURL=AirDropVerifierFactory.js.map